import { connect } from 'react-redux';

import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { IKnmErknmFormInspector } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormInspector';
import { IKnmErknmOrganizationTemplateSelectOption } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { IKnmErknmFormExpert } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormExpert';
import { IRequirementsNpaInitValues } from 'KnmPackage/RequirementsNpaModalModule/components/RequirementsNpaModal';
import { ActTypesEnum } from 'KnmErknmPackage/ErknmActsModule/enums';
import { getActBlockId } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getKnmDataCreated,
  getKnmErknmPositionsSelectOptions,
  getKnmOnSaveButtonClick,
  getKnmStatus,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { InspectionResultActionTypeEnum } from 'APIPackage/CatalogsModule/enums/InspectionResultActionTypeEnum';
import { getKnmStartDate } from 'KnmErknmPackage/MainModule/selectors/knmErknmSelectors';

import { ErknmActSubject } from './components/ErknmActSubject/ErknmActSubject';
import { KnmActViolations } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActViolations/KnmActViolations';
import { IKnmStatus } from '../../../../APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { IAdminSetting } from '../../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from '../../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { isLaterThanAdminSetting } from '../../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { KnmActEvents } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActEvents/KnmActEvents';
import { KnmActRemarks } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActRemarks/KnmActRemarks';
import { KnmActAdditional } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActAdditional/KnmActAdditional';
import { KnmActExtract } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActExtract/KnmActExtract';
import { KnmActGeneral } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActGeneral/KnmActGeneral';
import { KnmActGeneralImpossible } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActGeneralImpossible/KnmActGeneralImpossible';
import { KnmActParticipants } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActParticipants/KnmActParticipants';
import { KnmActSignInfo } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActSignInfo/KnmActSignInfo';
import { KnmActIntroductions } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActIntroductions/KnmActIntroductions';
import { KnmActSignButton } from '../../../../KnmPackage/KnmPaperlessActModule/KnmActSignButton/KnmActSignButton';
import { IDictionaryPositionSelectOption } from '../../../../CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { IDictionaryParticipantPositionSelectOption } from '../../../../CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';

interface IErknmPaperlessActContentKnmProps {
  acts: IKnmErknmFormAct[] | undefined;
  addRequirementsNpa: (actFieldName: string, fieldName: string) => void;
  addViolatedMandatory: (initialValue: IRequirementsNpaInitValues, fieldName: string, parentFieldName?: string) => void;
  expertsErknm: IKnmErknmFormExpert[] | undefined;
  formRef: IKnmFormRef | undefined;
  id: string;
  index: number;
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  isDisabledByComplete: boolean;
  isDisabledByDirty: boolean;
  isEnablePrescriptionCheck: boolean;
  isPrescriptionCheck: boolean;
  isWatchOnly: boolean;
  kindKnmCode: KnmKindCodesEnum | undefined;
  name: string;
  organizationsTemplatesSelectOptions: IKnmErknmOrganizationTemplateSelectOption[] | undefined;
  value: IKnmErknmFormAct;
}

interface IErknmPaperlessActContentKnmStoreProps {
  created: string | null | undefined;
  knmStatus: IKnmStatus | undefined;
  onSaveButtonClick: (() => void) | undefined;
  settings: IAdminSetting[] | undefined;
  startDateKnm: string | undefined;
  positionsSelectOptions: IDictionaryPositionSelectOption[] | IDictionaryParticipantPositionSelectOption[] | undefined;
}

const ErknmPaperlessActContentKnmWithoutStore = ({
  acts,
  addRequirementsNpa,
  addViolatedMandatory,
  expertsErknm,
  formRef,
  id,
  index,
  inspectorsErknm,
  isDisabledByComplete,
  isDisabledByDirty,
  isEnablePrescriptionCheck,
  isPrescriptionCheck,
  isWatchOnly,
  kindKnmCode,
  name,
  organizationsTemplatesSelectOptions,
  value,
  created,
  knmStatus,
  onSaveButtonClick,
  settings,
  startDateKnm,
  positionsSelectOptions,
}: IErknmPaperlessActContentKnmProps & IErknmPaperlessActContentKnmStoreProps) => {
  const { organizationTemplate, organization, involvedExperts, typeAct } = value;

  if (!typeAct) return null;

  const isNewOrganizationTemplate = !!organizationTemplate && !organizationTemplate.value;
  const actOrganizationsTemplatesSelectOptions:
    | IKnmErknmOrganizationTemplateSelectOption[]
    | undefined = organizationsTemplatesSelectOptions
    ?.filter(organizationTemplateSelectOption => {
      const isSelectedOrganizationTemplate =
        organizationTemplateSelectOption.id === organizationTemplate?.id ||
        organizationTemplateSelectOption.id === organization?.listId ||
        organizationTemplateSelectOption.value === organizationTemplate?.value;

      return (
        !(isNewOrganizationTemplate && organizationTemplateSelectOption.id === organization?.listId) &&
        (isSelectedOrganizationTemplate ||
          !organizationTemplateSelectOption.inspectionResults?.find(
            i => i.resultActionType === InspectionResultActionTypeEnum.LIGHT_RED,
          ))
      );
    })
    .map(organizationTemplateSelectOption => ({
      ...organizationTemplateSelectOption,
      isDisabled: acts?.some(
        actsItem =>
          organizationTemplateSelectOption.value &&
          actsItem?.organization?.listId === organizationTemplateSelectOption.id &&
          organization?.listId !== organizationTemplateSelectOption.id,
      ),
    }));

  const isDisabledField =
    isWatchOnly || isDisabledByComplete || !!value.signed || isDisabledByDirty || !!value.document;
  const prefixActBlockId = getActBlockId(value.listId);

  const isUseSigners = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ADD_NEW_SIGNER_199_4_1_6_STARTS_FROM,
  );

  return (
    <>
      <KnmActExtract extract={value.document} />
      {typeAct.id === ActTypesEnum.KNM_ACT ? (
        <KnmActGeneral
          isKnm
          name={name}
          isDisabledField={isDisabledField}
          prefixId={prefixActBlockId}
          startDate={startDateKnm}
          extractVersion={value.extractVersion}
          signActDateTime={value.signActDateTime}
        />
      ) : (
        <KnmActGeneralImpossible
          isKnm
          name={name}
          isDisabledField={isDisabledField}
          value={value}
          prefixId={prefixActBlockId}
          formRef={formRef}
        />
      )}
      {typeAct.id === ActTypesEnum.KNM_ACT_IMPOSSIBLE && kindKnmCode === KnmKindCodesEnum.RO && (
        <ErknmActSubject
          id={id}
          kindKnmCode={kindKnmCode}
          organizationsTemplatesSelectOptions={actOrganizationsTemplatesSelectOptions}
          name={name}
          isDisabledField={isDisabledField}
          value={value}
        />
      )}
      {typeAct.id === ActTypesEnum.KNM_ACT && (
        <>
          <ErknmActSubject
            id={id}
            kindKnmCode={kindKnmCode}
            organizationsTemplatesSelectOptions={actOrganizationsTemplatesSelectOptions}
            name={name}
            isDisabledField={isDisabledField}
            value={value}
          />
          <KnmActParticipants
            isKnm
            id={id}
            index={index}
            inspectorsErknm={inspectorsErknm}
            isDisabledField={isDisabledField}
            name={name}
            expertsErknm={expertsErknm}
            involvedExperts={involvedExperts}
            formRef={formRef}
          />
          <KnmActEvents
            id={id}
            name={name}
            isDisabledField={isDisabledField}
            actIndex={index}
            formRef={formRef}
            isPaperless={value.paperless}
            value={value}
            knmStatus={knmStatus}
            expertsErknm={expertsErknm}
          />
          <KnmActViolations
            addRequirementsNpa={addRequirementsNpa}
            addViolatedMandatory={addViolatedMandatory}
            id={id}
            index={index}
            isWatchOnly={isWatchOnly}
            name={name}
            value={value}
            isDisabledField={isDisabledField}
            isDisabledByDirty={isDisabledByDirty}
            formRef={formRef}
            isPaperless={true}
            isEnablePrescriptionCheck={isEnablePrescriptionCheck}
            isPrescriptionCheck={isPrescriptionCheck}
          />
        </>
      )}
      <KnmActSignInfo
        formRef={formRef}
        id={id}
        value={value}
        isDisabledField={isDisabledField}
        isErp={false}
        isKnm={true}
        name={name}
        inspectors={inspectorsErknm}
        isUseSigners={isUseSigners}
        positionsSelectOptions={positionsSelectOptions}
      />

      {value.document && (
        <>
          <KnmActIntroductions id={id} name={name} formRef={formRef} isDisabledByDirty={isDisabledByDirty} />
          {typeAct.id === ActTypesEnum.KNM_ACT && (
            <>
              <KnmActRemarks
                id={id}
                name={name}
                formRef={formRef}
                isDisabledByDirty={isDisabledByDirty}
                holdingDateTime={value.holdingDateTime}
              />
              {value.fileInvalidate && <KnmActAdditional name={name} attachment={value.fileInvalidate} />}
            </>
          )}
        </>
      )}
      <KnmActSignButton
        value={value}
        formRef={formRef}
        onSaveButtonClick={onSaveButtonClick}
        actIndex={index}
        name={name}
      />
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmPaperlessActContentKnmStoreProps => ({
  created: getKnmDataCreated(state),
  knmStatus: getKnmStatus(state),
  onSaveButtonClick: getKnmOnSaveButtonClick(state),
  settings: getAdminFetchSettings(state),
  startDateKnm: getKnmStartDate(state),
  positionsSelectOptions: getKnmErknmPositionsSelectOptions(state),
});

export const ErknmPaperlessActContentKnm = connect(mapStateToProps)(ErknmPaperlessActContentKnmWithoutStore);
